<template>
  <v-container
    v-if="shiftModel"
    class="mt-4">
    <v-row>
      <v-col cols="4">
        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="labour_hours_of_production_per_shift_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="number_of_shifts_of_the_labour_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="labour_days_of_production_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="labour_weeks_of_production_shiftModel"
          :rules="[positive]" />

        <CalcOutput
          :id="props.id"
          class="mb-4"
          field="labour_hours_of_production_per_year_shiftModel" />
      </v-col>

      <v-col cols="4">
        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="machine_hours_of_production_per_shift_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="number_of_shifts_of_the_machine_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="machine_days_of_production_shiftModel"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.id"
          class="mb-4"
          field="machine_weeks_of_production_shiftModel"
          :rules="[positive]" />

        <CalcOutput
          :id="props.id"
          class="mb-4"
          field="machine_hours_of_production_per_year_shiftModel" />
      </v-col>

      <v-col
        id="production_notes_col"
        size="4">
        <NotesEditor
          :id="id"
          field="production_notes_shiftModel"
          :placeholder="
            $t('entities.shiftModel.fields.production_notes_shiftModel')
          " />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";

import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import { useSpaceStore } from "@/stores/spaceStore";
import CalcOutput from "@/components/Elements/CalcOutput.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const props = defineProps({
  id: {
    type: String,
    required: true
  }
});

const spaceStore = useSpaceStore();
const shiftModel = ref(null);

onMounted(() => {
  shiftModel.value = spaceStore.getElement(props.id);
});

const { t } = useTranslation();

const { positive } = useCommonRules(t);
</script>

<style scoped>
#production_notes_col {
  height: 180px !important;
}
</style>
